"use client"

import { usePathname } from "next/navigation"
import { Fragment } from "react"
/**
 * This is used to wrap the header in a client component so that the header can be updated when the pathname changes.
 * This is because when routing (using the app router) the links are not updated correctly in the HTML.
 * @param children - The children to wrap
 */
export default function HeaderClientWrapper({ children }: { children: React.ReactNode }) {
    const pathname = usePathname()
    return <Fragment key={pathname}>{children}</Fragment>
}
